import { List } from 'immutable';

import { ogqlEffects } from './effects';
import { exportModule } from './module';
import { ogqlState } from './state';

export const ogqlModule = exportModule({
  effects: List([ogqlEffects]),
  state: List([ogqlState])
});
